import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { AI_APPS } from '../../../consts';
import { style } from '../Tabs/style';

/**
 * Top-nav "AI" dropdown listing the embedded agent-native apps. Selecting one
 * navigates to /ai/<app>, which renders the app in a same-origin iframe.
 * Apps flagged `external` (Clips, Analytics) are excluded here — they live as
 * top-level tabs that open standalone in a new browser tab.
 */
const AiAppsMenu = (): JSX.Element => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const menuApps = AI_APPS.filter((a) => !a.external);
  const active = location.pathname.split('/')[1] === 'ai';

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const closeMenu = (): void => setAnchorEl(null);
  const select = (key: string): void => {
    closeMenu();
    navigate(`/ai/${key}`);
  };

  return (
    <>
      <Button
        variant={ style.variant }
        size={ style.size }
        onClick={ openMenu }
        endIcon={ <KeyboardArrowDownIcon /> }
        sx={ { color: active ? style.colorActive : style.colorDefault } }
      >
        { translate(STRING_KEYS.LAYOUT_AI_TITLE) }
      </Button>
      <Menu anchorEl={ anchorEl } open={ open } onClose={ closeMenu }>
        { menuApps.map(({ key, label }) => (
          <MenuItem key={ key } onClick={ () => select(key) }>
            { label }
          </MenuItem>
        )) }
      </Menu>
    </>
  );
};

export default AiAppsMenu;
